import React from 'react'
import { Row, Col } from 'pui-react-grids'
import Paper from 'material-ui/Paper'
import { themeColors } from '../../styles/theme'
import Monetization from 'material-ui/svg-icons/editor/monetization-on'
import { Card, CardTitle, CardText } from 'material-ui/Card'
import { connect } from 'react-redux'

const styles = {
  paper: {
    padding: 20,
  },
  title: {
    color: themeColors.energized,
  },
  ecoinsNum: {
    color: themeColors.secondary,
    marginLeft: 5,
    fontSize: 30,
  },
  ecoinsContainer: {
    padding: 10,
    backgroundColor: themeColors.lightpositive,
    textAlign: 'center',
  },
  ecoinsIcon: {
    color: themeColors.energized,
    position: 'relative',
    top: 6,
    marginRight: 5,
  },
  text: {
    padding: 10,
    color: themeColors.energized,
    marginTop: 20,
  },
  card: {
    marginBottom: 10,
  },
}

const Ecoins = ({ user, counts }) => (
  <div>
    <div className="padding">
      <Paper style={styles.paper}>
        {/* al momento il servizi aggiuntivi non sono disponibili, questo è il testo provvisorio */}
        <p>
          Causa aggiornamento del Sito i servizi aggiuntivi non sono momentaneamente disponibili.
          <br />
          Ci scusiamo per il disagio, li riattiveremo il prima possibile.
        </p>
        <Row>
          <Col md={24}>
            <Paper style={styles.ecoinsContainer}>
              <h3 style={styles.title}>
                <Monetization style={styles.ecoinsIcon} />
                eCoin disponibili:
                {' '}
                <span style={styles.ecoinsNum}>{counts.ecoins}</span>
              </h3>
            </Paper>
            {/* <div style={styles.text}>
              <p>
                Puoi usare gli eCoin
                {' '}
                <span role="img" aria-label="Money">💰</span>
                {' '}
                per usufruire dei fantastici servizi che Swapick ti mette a disposizione.
                <br />
                {' '}
                Scopri cosa puoi fare con gli eCoin:
              </p>
            </div> */}
          </Col>
        </Row>
        {/* <Row>
          <Col md={12}>
            <Card containerStyle={styles.card}>
              <CardTitle
                title="Metti in evidenza il tuo oggetto"
                titleColor={themeColors.positive}
              />
              <CardText>
                Aumenta le tue possibilità di scambio rendendo più visibile il tuo oggetto! Mettilo in evidenza, nella prima riga del magazzino, così che molte più persone possano vederlo!
              </CardText>
            </Card>
          </Col>
          <Col md={12}>
            <Card containerStyle={styles.card}>
              <CardTitle
                title="Metti il tuo oggetto 'in cima'"
                titleColor={themeColors.positive}
              />
              <CardText>
                Aumenta le tue possibilità di scambio rendendo più visibile il tuo oggetto! Mettilo in cima al magazzino, subito dopo gli oggetti in evidenza, così che molte più persone possano vederlo!
              </CardText>
            </Card>
          </Col>
        </Row> */}
      </Paper>
    </div>
  </div>
)

const mapStateToProps = state => ({
  user: state.auth.user,
  counts: state.loggedUserCounts.counts,
})

export default connect(mapStateToProps)(Ecoins)



// WEBPACK FOOTER //
// ./src/pages/Me/Ecoins.js